import script from "./IntegrationLoader.vue?vue&type=script&lang=js"
export * from "./IntegrationLoader.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__